export const dataHooks = {
    header: 'sidebar-header',
    footer: 'sidebar-footer',
    scrollBarGradient: 'scroll-bar-gradient',
    scrollArea: 'sidebar-content-wrapper',
    skeleton: 'sidebar-skeleton',
    minimizeButton: 'minimize-button',
};
export const sidebarSkins = {
    dark: 'dark',
    light: 'light',
    neutral: 'neutral',
};
//# sourceMappingURL=constants.js.map